import { Injectable, signal, Signal, WritableSignal, computed } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SpinnerService {

    private _activeRequests: WritableSignal<number> = signal(0);
    public isLoading: Signal<boolean> = computed(() => this._activeRequests() > 0);

    public on(): void {
        this._activeRequests.update(count => count + 1);
    }

    public off(): void {
        this._activeRequests.update(count => Math.max(0, count - 1));
    }

}
